import { JSEncrypt } from 'jsencrypt';

const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDDtg/3f+Aq1nDHB8s6SX5rNM1y+dr/nnLR+H+7HHZeQyMiH2YePDrgKULMoKPYYBBsbZxgX32uNyqQAw8GwOiC0/txMvkF+/ZojtTacJ3ohK29InPVTojmpmo+V/OdFglhEQw2xI9uFrZEQ9UA8kHrAe1m0m+OcqIGs7pWg214LwIDAQAB';

const privateKey = 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAMO2D/d/4CrWcMcHyzpJfms0zXL52v+ectH4f7scdl5DIyIfZh48OuApQsygo9hgEGxtnGBffa43KpADDwbA6ILT+3Ey+QX79miO1NpwneiErb0ic9VOiOamaj5X850WCWERDDbEj24WtkRD1QDyQesB7WbSb45yogazulaDbXgvAgMBAAECgYA/BCpT+PrHEFEz5NCNLgjkoBXfBZB8ahpyfV8zclCyvU9ct1t8NMyITQDTPo5DJ3tiTlDhvx2KsPylbjayZ/71QPJia/fZJDkc1FapDPcZql+ooad+9ePzWgwiBrY1WsKovR+8fLdjjz2C8KTt2j7ps67SI+8I/kJwNtCSj1s9EQJBAOasIYxcw/uEAcMivH362k04GeSv5qzoUD92Df5CGcWAaRrtNYi6uBTbASaHE3XvAMXkD4jN/pXHftnfmdEiaMsCQQDZMzjdDbLZPBBN7ApZBoCZavlVyMb+LhMpvorRNep4NH2UuScs+784N5TCBzgOYOQjIt4uavul4V37YGLHPBWtAkEAuorDSqaOWy1C25KQynR96+qNjhHuQzBQDTIkWNUN0FlrJjpki6EsUrlVMdoUk8/nWSF4qpKj6m59mCYqVyUzhwJASc2S6+IkvJYhQCkNlxSTjA4CbTjNDT+guVWKm+5DHtdPOML1Yd6lKjgQryF+1bvsqVfGwWUO313F7o3g4qwy/QJATEbS935VMSMj5PyXlf93ppxJhfysf+49nupofR+6caRzR5nMnQuT6+JQWa2y1IX3prEf1Z7Yw3RPpHEJeqVPRQ==';

export const encrypt = (txt: string) => {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);
  return encryptor.encrypt(txt);
};

export const decrypt = (txt: string) => {
  const encryptor = new JSEncrypt();
  encryptor.setPrivateKey(privateKey);
  return encryptor.decrypt(txt);
};

export { publicKey, privateKey };
